import { createContext, useContext, type ReactNode } from 'react';
import { useLocalStorage } from '../hooks/useBrowser';

interface AccountFilter {
  /** Selected mailbox id, or null for "All accounts". */
  accountId: string | null;
  setAccountId: (id: string | null) => void;
}

const Ctx = createContext<AccountFilter>({ accountId: null, setAccountId: () => undefined });

export function AccountFilterProvider({ children, workspaceId }: { children: ReactNode; workspaceId: string }) {
  const [accountId, setAccountId] = useLocalStorage<string | null>(`mp:account:${workspaceId}`, null);
  return <Ctx.Provider value={{ accountId, setAccountId }}>{children}</Ctx.Provider>;
}

export const useAccountFilter = () => useContext(Ctx);
